var React = require('react');

function Arrow24 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.3787 13.5L3 13.5V10.5L17.3787 10.5L13.9393 7.06067L16.0607 4.93935L22.0607 10.9394C22.6464 11.5251 22.6464 12.4749 22.0607 13.0607L16.0607 19.0607L13.9393 16.9394L17.3787 13.5Z","fill":"white"}));
}

Arrow24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Arrow24;

Arrow24.default = Arrow24;
